export const INVALID_S3_KEY_CHARACTERS = [
    '%',
    '?',
    '#',
    '@',
    '+',
    "'",
    '–',
    ']',
    '[',
    '{',
    '}',
    '\\',
    '§',
    '©',
    'ß',
    '€',
    '®',
    '™',
    '`'
];
export const INVALID_UPLOAD_CHARACTERS = [...INVALID_S3_KEY_CHARACTERS, '/', '—'];
export const INVALID_UPLOAD_CHARACTERS_REGEX = new RegExp(`[${INVALID_UPLOAD_CHARACTERS.join('').replace(/[\[\]\\]/g, '\\$&')}]`, 'g');
export const INVALID_S3_KEY_CHARACTERS_REGEX = new RegExp(`[${INVALID_S3_KEY_CHARACTERS.join('').replace(/[\[\]\\]/g, '\\$&')}]`, 'g');
//# sourceMappingURL=invalidUploadCharacters.js.map